var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"tb-price-disclaimer"},[_vm._v("Indicative model and pricing only. Due to extended wait times, the final vehicle we can offer you and its price are likely to be different.")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }